import image1 from "./images/furniture-bg-1.png";
import image2 from "./images/furniture-bg-2.png";
import image3 from "./images/furniture-bg-3.png";
import image4 from "./images/furniture-bg-4.png";
import image5 from "./images/chairs-bg-1.png";
import image6 from "./images/outdoor-bg-1.png";

// import transparentSofa2 from "./images/transparent-sofa-2.png";
// import transparentSofa3 from "./images/transparent-sofa-3.png";
// import transparentChair1 from "./images/transparent-chair-1.png";
// import transparentChair2 from "./images/transparent-chair-2.png";
// import transparentChair3 from "./images/transparent-chair-3.png";
// import transparentOutdoor1 from "./images/transparent-outdoor-1.png";
// import transparentOutdoor2 from "./images/transparent-outdoor-2.png";

export const sliderItems = [
  {
    id: 1,
    img: image1,
    title: "WINTER SALE",
    desc: "GET READY TO SNUGGLE UP AND GET WARM WITH 20% OFF LIVING ROOM FURNITURE",
    bg: "",
  },
  {
    id: 2,
    img: image2,
    title: "POPULAR SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF YOUR NEW ARRIVALS.",
    bg: "",
  },
  {
    id: 3,
    img: image3,
    title: "FALL SALE",
    desc: "GET THE BEST FALL COLORS WITH OUR GREAT STYLES OF PILLOWS AND CHAIRS.",
    bg: "",
  },
];

export const categories = [
  {
    id: 1,
    img: image4,
    title: "Sofas",
    category: "sofas",
  },
  {
    id: 2,
    img: image5,
    title: "Chairs",
    category: "chairs",
  },
  {
    id: 3,
    img: image6,
    title: "Outdoor",
    category: "outdoors",
  },
];

// We now use the database instead of this.
// export const popularProducts = [
//   {
//     id: 1,
//     img: "https://i.ibb.co/sqxbqSN/transparent-sofa-1.png",
//   },
//   {
//     id: 2,
//     img: transparentSofa2,
//   },
//   {
//     id: 3,
//     img: transparentSofa3,
//   },
//   {
//     id: 4,
//     img: transparentChair1,
//   },
//   {
//     id: 5,
//     img: transparentChair2,
//   },
//   {
//     id: 6,
//     img: transparentChair3,
//   },
//   {
//     id: 7,
//     img: transparentOutdoor1,
//   },
//   {
//     id: 8,
//     img: transparentOutdoor2,
//   },
// ];
